import parentContractsService from "@/services/parentContractsService";

const state = () => ({
});

const actions = {
  async search({ dispatch }, payload) {
    try {
      const res = await parentContractsService.search(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Verträge konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAll({ dispatch }) {
    try {
      const res = await parentContractsService.getAll();
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Verträge konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
